import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-780044fe")

_pushScopeId("data-v-780044fe")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "営業時間", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("開始時刻 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("終了時刻 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_validate_edit_box_time = _resolveComponent("validate-edit-box-time")
  const _component_alert_message = _resolveComponent("alert-message")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_validate_edit_box_time, {
      class: "vue-content-edit-box",
      title: "開始時刻",
      placeholder: "0000～2359",
      validation: _ctx.submitted ? _ctx.startTimeError : undefined,
      required: true,
      "time-unit": _ctx.appointmentTimeUnit,
      modelValue: _ctx.startTime,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.startTime = $event))
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["validation", "time-unit", "modelValue"]),
    _createVNode(_component_validate_edit_box_time, {
      class: "vue-content-edit-box",
      title: "終了時刻",
      placeholder: "0000～2359",
      validation: _ctx.submitted ? _ctx.endTimeError : undefined,
      required: true,
      "time-unit": _ctx.appointmentTimeUnit,
      modelValue: _ctx.endTime,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.endTime = $event))
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["validation", "time-unit", "modelValue"]),
    (_ctx.submitted && _ctx.timeOrderError)
      ? (_openBlock(), _createBlock(_component_alert_message, { key: 0 }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.timeOrderError), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})